// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeConcept_home-concept__dC3RQ {
  display: flex;
  padding: 100px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 48px;
  align-self: stretch;
  background: var(--background-color-2);
}
.HomeConcept_home-concept__dC3RQ .HomeConcept_home-concept__container__bESpB {
  display: flex;
  align-items: center;
  gap: 48px;
  align-self: stretch;
}
.HomeConcept_home-concept__dC3RQ .HomeConcept_home-concept__left__90eF6 {
  display: flex;
  flex: 3 1;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 32px;
}
.HomeConcept_home-concept__dC3RQ .HomeConcept_home-concept__left--title__2lQ2F {
  color: var(--accent-color);
  font-size: 32px;
}
.HomeConcept_home-concept__dC3RQ .HomeConcept_home-concept__left--description__lZY1c {
  color: var(--text-1);
}
.HomeConcept_home-concept__dC3RQ .HomeConcept_home-concept__left--button__j9vUX {
  background-color: var(--accent-color);
  text-transform: initial;
}
.HomeConcept_home-concept__dC3RQ .HomeConcept_home-concept__left--button__j9vUX svg {
  fill: white;
}
.HomeConcept_home-concept__dC3RQ .HomeConcept_home-concept__right__c8jWu {
  flex: 4 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
.HomeConcept_home-concept__dC3RQ .HomeConcept_home-concept__right--image__EaXWk {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.HomeConcept_home-concept__dC3RQ .HomeConcept_home-concept__right--image__container__B8vWt {
  aspect-ratio: 679/343.41;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Home/Components/HomeConcept/HomeConcept.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,qCAAA;AACF;AAEI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAAN;AAEI;EACE,aAAA;EACA,SAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;AAAN;AAEM;EACE,0BAAA;EACA,eAAA;AAAR;AAGM;EACE,oBAAA;AADR;AAIM;EACE,qCAAA;EACA,uBAAA;AAFR;AAIQ;EACE,WAAA;AAFV;AAMI;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;AAJN;AAMM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAJR;AAMQ;EACE,wBAAA;AAJV","sourcesContent":[".home-concept {\n  display: flex;\n  padding: 100px 24px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 48px;\n  align-self: stretch;\n  background: var(--background-color-2);\n\n  .home-concept {\n    &__container {\n      display: flex;\n      align-items: center;\n      gap: 48px;\n      align-self: stretch;\n    }\n    &__left {\n      display: flex;\n      flex: 3;\n      flex-direction: column;\n      justify-content: center;\n      align-items: flex-start;\n      gap: 32px;\n\n      &--title {\n        color: var(--accent-color);\n        font-size: 32px;\n      }\n\n      &--description {\n        color: var(--text-1);\n      }\n\n      &--button {\n        background-color: var(--accent-color);\n        text-transform: initial;\n\n        svg {\n          fill: white;\n        }\n      }\n    }\n    &__right {\n      flex: 4;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: flex-start;\n\n      &--image {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n\n        &__container {\n          aspect-ratio: 679/343.41;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home-concept": `HomeConcept_home-concept__dC3RQ`,
	"home-concept__container": `HomeConcept_home-concept__container__bESpB`,
	"home-concept__left": `HomeConcept_home-concept__left__90eF6`,
	"home-concept__left--title": `HomeConcept_home-concept__left--title__2lQ2F`,
	"home-concept__left--description": `HomeConcept_home-concept__left--description__lZY1c`,
	"home-concept__left--button": `HomeConcept_home-concept__left--button__j9vUX`,
	"home-concept__right": `HomeConcept_home-concept__right__c8jWu`,
	"home-concept__right--image": `HomeConcept_home-concept__right--image__EaXWk`,
	"home-concept__right--image__container": `HomeConcept_home-concept__right--image__container__B8vWt`
};
export default ___CSS_LOADER_EXPORT___;
